/**
 * A list of colors.
 */
export var NamedColorsHEX;
(function (NamedColorsHEX) {
    NamedColorsHEX["DarkSeaTurquoise"] = "#13A8A0";
    NamedColorsHEX["KahPurple"] = "#4F3978";
    NamedColorsHEX["LightSeaGreen"] = "#20A4C8";
    NamedColorsHEX["LightSeaTurquoise"] = "#17D3C9";
    NamedColorsHEX["LightSlateGray"] = "#9182AC";
    NamedColorsHEX["PantoneAquaSky"] = "#7BC4C4";
    NamedColorsHEX["PantoneBlueIris"] = "#5A5B9F";
    NamedColorsHEX["PantoneBlueTurquoise"] = "#53B0AE";
    NamedColorsHEX["PantoneCanoliCream"] = "#F0EFE2";
    NamedColorsHEX["PantoneCeruleanBlue"] = "#98B2D1";
    NamedColorsHEX["PantoneChiliPepper"] = "#9B1B30";
    NamedColorsHEX["PantoneClassicBlue"] = "#0F4C81";
    NamedColorsHEX["PantoneCoconutMilk"] = "#F0EDE5";
    NamedColorsHEX["PantoneCoolGray1C"] = "#D9D9D6";
    NamedColorsHEX["PantoneEmerald"] = "#009474";
    NamedColorsHEX["PantoneFuchsiaRose"] = "#C74375";
    NamedColorsHEX["PantoneGreenery"] = "#88B04B";
    NamedColorsHEX["PantoneHoneysuckle"] = "#D94F6F";
    NamedColorsHEX["PantoneLivingCoral"] = "#FF6F61";
    NamedColorsHEX["PantoneMarsala"] = "#964E4C";
    NamedColorsHEX["PantoneMimosa"] = "#F0C15A";
    NamedColorsHEX["PantonePeachQuarts"] = "#F5B895";
    NamedColorsHEX["PantonePixie"] = "#CEA8BF";
    NamedColorsHEX["PantoneRadiantOrchid"] = "#AD5E99";
    NamedColorsHEX["PantoneRoseQuartz"] = "#F7CAC9";
    NamedColorsHEX["PantoneSandDollar"] = "#DECDBE";
    NamedColorsHEX["PantoneSerenity"] = "#91A8D0";
    NamedColorsHEX["PantoneTangerineTango"] = "#DD4024";
    NamedColorsHEX["PantoneTigerlily"] = "#E2583E";
    NamedColorsHEX["PantoneTrueRed"] = "#BF1932";
    NamedColorsHEX["PantoneTurquoise"] = "#45B5AA";
    NamedColorsHEX["PantoneUltraViolet"] = "#5F4B8B";
    NamedColorsHEX["SandyBrown"] = "#F3A347";
    NamedColorsHEX["SlateBlue"] = "#505BD3";
})(NamedColorsHEX || (NamedColorsHEX = {}));
export var BORDER_COLOR = '#9182AC';
export var BORDER_RADIUS_PX = 4;
export var FONT_SIZE_PX = 15;
/**
 * Screen resolutions for breakpoint purposes.
 */
export var ScreenSizesPx;
(function (ScreenSizesPx) {
    ScreenSizesPx[ScreenSizesPx["small"] = 576] = "small";
    ScreenSizesPx[ScreenSizesPx["medium"] = 768] = "medium";
    ScreenSizesPx[ScreenSizesPx["large"] = 992] = "large";
    ScreenSizesPx[ScreenSizesPx["extraLarge"] = 1200] = "extraLarge";
})(ScreenSizesPx || (ScreenSizesPx = {}));
//# sourceMappingURL=constants.js.map